import { RoseTree } from '@tableau/data-structures';
import { NestedProjectBasicInfo, NestedProjectsTreeHelper } from '@tableau/nested-project-explorer';
import { SliceableHelper } from '../helpers/SliceableHelper';
import { DestinationProjectMapper } from '../mappers/DestinationProjectMapper';
import { Module } from '../Module';
import { DestinationProjects } from '../resources/DestinationProjects';

export class UploadContentService {
  public static $inject = [
    'DestinationProjects'
  ];

  constructor(
    private destinationProjects: DestinationProjects
  ) { }

  public getAllProjectsAsTrees(
    query: string,
    itemIds: string[],
  ): ng.IPromise<RoseTree<NestedProjectBasicInfo>[]> {
    const contentType = 'project';
    const projectsQuery = this.destinationProjects.getQueryForSpecificSourceContentAndMatchText(contentType, itemIds, query);
    return SliceableHelper.fetchAll(projectsQuery).then(projects => {
      const destinationProjects = DestinationProjectMapper.map(projects.items);
      const nestedProjects = NestedProjectsTreeHelper.convertProjectListToTrees(destinationProjects);
      return nestedProjects;
    });
  }
}

Module.instance().service('UploadContentService', UploadContentService);
